module.exports = __webpack_public_path__ + "static/media/logo.470ce826.jpg";